import React from "react";

export default function Footer() {
  return (
    <a
      href="https://github.com/damanatidis00/Weather-App-Project"
      className="footer"
      target="_blank"
      rel="noreferrer"
    >
      Open source code by Despina
    </a>
  );
}
